import Api from '@/services/ServiceBase'
const path = 'apps'

export default {
  addUpdate(item) {
    return Api().post(path, item)
  },
  list(name, page) {
    return Api().get(path, {
      params: {
        name,
        page
      }
    })
  },
  show(id) {
    return Api().get(path + `/${id}`)
  },
  delete(id) {
    return Api().delete(path + `/${id}`)
  }
}
